import React from 'react';
import UsersTab from '../../components/admin/UsersTab';

const BenutzerPage = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Benutzer</h1>
        <p className="text-sm text-gray-600">Admin-Benutzer verwalten</p>
      </div>
      <UsersTab />
    </div>
  );
};

export default BenutzerPage;
